<template>
<div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {

    };
  }
};
</script>

<style>
@import url("https://cdn.morningstar.com.au/mds/custom/2.36.0/mds-intrinsic.css");

</style>
